import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "truncate py-0.5"
}
const _hoisted_2 = {
  key: 2,
  class: "truncate py-0.5 font-semibold"
}

import HierarchyTagItem from "shared/components/other/HierarchyTagItem.vue";
import { HierarchyTagStore } from "shared/types/HierarchyTag";
import { PlannerItemWithChildren } from "shared/types/Plan";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectProgressItemName',
  props: {
    plannerItem: {},
    tags: {},
    simplified: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["flex-1 truncate flex gap-1", {
      'font-semibold': _ctx.plannerItem.children && _ctx.plannerItem.children.length > 0,
    }])
  }, [
    (
        !_ctx.simplified &&
        (_ctx.tags.length === 0 || (_ctx.plannerItem.children && _ctx.plannerItem.children.length > 0))
      )
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.plannerItem.name), 1))
      : (!_ctx.simplified)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.tags, (tag) => {
            return (_openBlock(), _createBlock(HierarchyTagItem, {
              key: tag._id,
              tag: tag
            }, null, 8, ["tag"]))
          }), 128))
        : _createCommentVNode("", true),
    (_ctx.simplified)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.tags.map((tag) => tag.name).join(", ")), 1))
      : _createCommentVNode("", true)
  ], 2))
}
}

})